import type { FC, HTMLAttributes, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

type Style = HTMLAttributes<HTMLElement>["style"];

const PdfPreviewHeading: FC<Props> = ({ children }) => {
  const heading: Style = {
    width: "100%",
    display: "inline-block",
    margin: "12px 0",
    fontSize: 19,
    fontWeight: "bold",
    color: "#000",
    textAlign: "center",
  };

  return <h1 style={heading}>{children}</h1>;
};

export default PdfPreviewHeading;